import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';

export interface SyncProgress {
  processed: number;
  created: number;
  updated: number;
  skipped: number;
  failed: number;
}

interface SyncButtonProps {
  syncing: boolean;
  disabled: boolean;
  onSync: () => void;
  progress?: SyncProgress | null;
}

const SyncButton: React.FC<SyncButtonProps> = ({
  syncing,
  disabled,
  onSync,
  progress
}) => {
  const progressLabel =
    progress &&
    [
      progress.created > 0 && `${progress.created} created`,
      progress.updated > 0 && `${progress.updated} updated`
    ]
      .filter(Boolean)
      .join(', ');
  const buttonLabel = syncing
    ? progressLabel
      ? `Syncing… ${progressLabel}`
      : 'Syncing…'
    : 'Sync to CRM';

  return (
    <Box
      sx={{
        mt: 'auto',
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        flexShrink: 0
      }}
    >
      <Button
        variant="contained"
        fullWidth
        onClick={onSync}
        disabled={disabled}
        startIcon={
          syncing ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            <SyncIcon sx={{ fontSize: 20 }} />
          )
        }
        sx={(theme) => ({
          border: `1px solid ${theme.customColors?.themePrimary || 'primary.main'}`,
          backgroundColor: theme.customColors?.themePrimary || 'primary.main',
          color: theme.customColors?.themeSecondary || 'white',
          borderRadius: '50px',
          textTransform: 'capitalize',
          py: 1.5,
          '&:disabled': {
            borderColor: 'inherit',
            opacity: 0.6
          }
        })}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};

export default SyncButton;
